import { AppConfig, ConfigProvider, ModuleRegisterFunction, Runtime } from '@sgi/af-shell-shared';
import { faIdCardClip } from '@fortawesome/pro-light-svg-icons/faIdCardClip';
import { Container } from '@chakra-ui/layout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { assignConfig } from '../config';
import { Outlet } from 'react-router-dom';
import { DriverSearch } from 'src/pages/driver';

/* this is only used with mfe */
export const register: ModuleRegisterFunction = async (runtime: Runtime) => {
  const config: AppConfig = (window as any)['runConfig'];
  assignConfig(config);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });

  runtime.registerRoutes([
    {
      element: (
        <ConfigProvider value={config}>
          <QueryClientProvider client={queryClient}>
            <Container p={4}>
              <Outlet />
            </Container>
          </QueryClientProvider>
        </ConfigProvider>
      ),
      // path: '',
      children: [
        {
          path: 'driver',
          element: <DriverSearch />,
        },
      ],
    },
  ]);

  runtime.registerNavigationItems([
    {
      to: ``,
      itemContent: 'Driver Hub',
      additionalProps: { icon: faIdCardClip },
      priority: 100,
      isVisible: true, //TODO use feature flag
      children: [
        {
          to: 'Manage',
          itemContent: 'Manage',
          isVisible: true,
          children: [
            {
              to: '/driver',
              itemContent: 'Driver Search',
            },
          ],
        },
      ],
    },
  ]);
};
